import { render, staticRenderFns } from "./CompanyList.vue?vue&type=template&id=0a481fa7&"
import script from "./CompanyList.vue?vue&type=script&lang=js&"
export * from "./CompanyList.vue?vue&type=script&lang=js&"
import style0 from "./CompanyList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports